import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography, IconButton } from '@material-ui/core';
import ArrowLeftIcon from '@material-ui/icons/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { actionAddOrderProduct, actionUpdateOrderProduct } from 'actions/actionShopCart';

import { DialogeBox, ErrorHandling } from 'components';
import { genfunction } from 'helpers'
import OrderProduct from './components/OrderProduct'
import SubMenuItem from './components/SubMenuItem'

const { ShowOrderItemPriceAs, OrderItemsInCartError2 } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    RightButtonlIcon: {
        '& svg': {
            fontSize: 40
        }
    }
}));

const OrderSubMenu = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");
    const [infoProduct, setInfoProduct] = useState(null);
    let [productPopUp, setProductPopUp] = useState({
        isOpen: false,
        Product: null,
        Department: null
    });

    const orderLocation = useSelector(state => state.reducerOrderLocations.orderLocation);
    const orderMenu = useSelector(state => state.reducerOrderMenu.orderMenu);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);

    const events = useSelector(state => state.reducerShopCart.events);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards.giftcards);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.match.path == "/ordersubmenu/:name") {

        }
        else {
            props.history.push('/notfound');
        }
    }, [])

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const onClickBackButtonHandler = () => {
        props.history.goBack();
    }

    const onClickProductHandler = (department, product) => {
        setProductPopUp({
            isOpen: true,
            Product: product,
            Department: department
        });
    }

    const onClickCancelProductHanlder = () => {
        errorcancelhandle();
        setProductPopUp({
            isOpen: false,
            Product: null,
            Department: null
        });
    }

    const hasSameOptions = (ProductA, ProductB) => {
        if (ProductA.Options && ProductB.Options) {
            return ProductA.Options.every(PAOption => {
                let PBOption = ProductB.Options.find(x => x.OptionName === PAOption.OptionName);
                if (PAOption.Products && PBOption.Products) {
                    let PAProduct = PAOption.Products.filter(x => x.IsSelected);
                    let PBProduct = PBOption.Products.filter(x => x.IsSelected);
                    if (PAProduct.length == PBProduct.length) {
                        return PAProduct.every(AProduct => {
                            if (PBProduct.find(x => x.ProductID === AProduct.ProductID) == undefined) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        });
                    }
                }
            });
        }
        else {
            return true;
        }
    }

    const isDifferentItemsAlreadyInCart = () => {
        if ((events && events.length > 0) || (gatickets && gatickets.length > 0) || (membershipPackages && membershipPackages.length > 0) || (giftcards && giftcards.length > 0) || (donationProducts && donationProducts.length > 0)) {
            return true;
        }
        else
            return false;
    }

    const onClickAddToCartProductHanlder = (Product) => {

        if (isDifferentItemsAlreadyInCart()) {
            seterrorMsg(OrderItemsInCartError2);
        }
        else if (Product.Quantity == 0) {
            seterrorMsg("Please select quantity")
        }
        else if (genfunction.IsRequiredOptionsSelectedForOrderItem(Product) == false) {
            seterrorMsg("Please select required option first");
        }
        else {
            errorcancelhandle();
            let objSelectedProducts = [...orderProducts];
            let objProduct = objSelectedProducts.find(p => p.ProductID === Product.ProductID && p.ProductNotes === Product.ProductNotes && hasSameOptions(p, Product));
            if (objProduct) {
                objProduct.Quantity += Product.Quantity;
                actionUpdateOrderProduct(dispatch, objProduct);
            }
            else {
                objProduct = Object.assign({}, Product);
                objProduct.UniqueID = uuidv4();
                actionAddOrderProduct(dispatch, objProduct);
            }
            setProductPopUp({
                isOpen: false,
                Product: null,
                Department: null
            });
        }
    }

    const onClickCheckoutHandler = () => {
        if (orderProducts && orderProducts.length > 0) {
            props.history.push('/revieworderproducts');
        }
        else {
            seterrorMsg("Please select item first");
        }
    }

    if (orderLocation == undefined || orderMenu == undefined)
        return null
    else
        return (
            <div style={{ paddingTop: window.matchMedia("(max-width: 500px)").matches ? 40 : 5 }}>
                <Grid className={classes.root} container spacing={2} justifyContent="center">
                    <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item xs={12} sm={9} md={6} lg={4} align="left">
                            <IconButton className={classes.RightButtonlIcon} onClick={onClickBackButtonHandler}>
                                <ArrowLeftIcon color={"primary"} />
                                <Typography style={{ paddingLeft: 20 }} variant="h1" color="textPrimary" >{props.match.params.name}</Typography>
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid item container spacing={1} xs={12} sm={9} md={6} lg={4} aligh="center">
                        {orderMenu.find(x => x.MenuName == props.match.params.name && x.Departments && x.Departments.length > 0).Departments.filter(x => x.Products).map(dep => {
                            return <SubMenuItem key={dep.DepartmentName} Department={dep} onClickAddProduct={onClickProductHandler} onClickProductInfo={setInfoProduct}  ></SubMenuItem>
                        })}
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item container spacing={1} xs={12} sm={9} md={6} lg={4} aligh="center">
                            <Grid item xs={6} align="left">
                                <Button variant="outlined" color="primary"
                                    onClick={() => { props.history.push('/orderlocation'); }}
                                >
                                    Start Over
                                </Button>
                            </Grid>
                            <Grid item xs={6} align="right">
                                <Button variant="contained" color="primary" onClick={onClickCheckoutHandler}>
                                    Checkout {genfunction.ccyFormat(ShowOrderItemPriceAs.toLowerCase() == "inctax" ? genfunction.getOrderProductsTotalPrice(orderProducts).total : genfunction.getOrderProductsTotalPrice(orderProducts).subtotal)}</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <DialogeBox open={infoProduct ? true : false} title={infoProduct ? genfunction.replaceEscapeCharacters(infoProduct.ProductName) : ""}
                        message={infoProduct ? genfunction.replaceEscapeCharacters(infoProduct.ProductDescription) : ""}
                        button1text={"Close"}
                        button1clickhandler={() => { setInfoProduct(null) }}>
                    </DialogeBox>
                    {productPopUp && productPopUp.Product ?
                        <OrderProduct open={productPopUp.isOpen} Product={productPopUp.Product}
                            onConfirm={onClickAddToCartProductHanlder}
                            onCancel={onClickCancelProductHanlder}
                        >
                        </OrderProduct>
                        : ""}
                </Grid>
            </div>
        );
};

export default OrderSubMenu;